import Headline, { type Props } from "./Headline";

const H1:React.FC<Props> = function H1({size = "3xl", ...props}) {
  return <Headline tag="h1" size={size} {...props}/>;
}
export default H1;